<!-- Form to update user Profile details -->
<!-- Verify user -->
<ng-container *ngIf="role === 'CUSTOMER'">
  
    <div class="view-account" style="margin-left:20px;">
    <h1>Customer Information</h1>
      <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
        <div>
          <div id="left">
            <fieldset class="field-1">

              <div>
                <h3>Company Info</h3>
                  <div class="row">

                    <!-- <div class="col-md-5" > -->
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li id="leftli">User ID </li> <br>
                            <li id="leftli">Company Name</li> <br>
                            <li id="leftli">Country</li> <br>
                            <li id="leftli">Company Phone</li> <br>
                            <li id="leftli">Company Email</li> <br>
                          </ul>
                        </div>
                      </div>
                    <!-- </div> -->

                    <!-- <div class="col-md-5" > -->
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li>
                            <input type="text" formControlName="userName" value={{userDetails.userName}}/>
                            </li> <br>
                            <!-- <li>
                            <input type="text" formControlName="fullName" value={{userDetails.fullName}}/>
                            </li> <br> -->
                            <li>
                            <input type="text" formControlName="companyName" value={{userDetails.companyName}}/>
                            </li> <br>
                            <li>
                            <input type="text" formControlName="country" value={{userDetails.country}}/>
                            </li> <br>
                            <li>
                              <input type="text" formControlName="contactNumber" value={{userDetails.contactNumber}}/>
                            </li> <br>
                            <li>
                              <input type="text" formControlName="email" value={{userDetails.email}}/>
                            </li> <br>
                          </ul>
                        </div>
                      </div>
                    <!-- </div> -->
                  </div>
              </div>


            </fieldset>


            <fieldset class="field-2">
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">

                  <!-- <div class="col-md-5" > -->
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li id="leftli">Contact Person </li> <br>
                          <li id="leftli">Phone Number </li> <br>
                          <li id="leftli">E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  <!-- </div> -->


                  <!-- <div class="col-md-5"> -->
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li><input type="text" formControlName="fullName" value={{userDetails.fullName}}/></li> <br>
                          <li><input type="text" formControlName="pContactNumber" value={{userDetails.pContactNumber}}/></li> <br>
                          <li><input type="text" formControlName="pEmail" value={{userDetails.pEmail}}/></li> <br>
                        </ul>
                      </div>
                    </div>
                  <!-- </div> -->


                </div>
              </div>
            </fieldset>



          </div>




          <div style="margin-right:20px;">
            <fieldset class="field-3">
              <br>
              <div class="row">
              <h3>License and Bank Details</h3>
              </div>
              <div class="row">


                <!-- <div class="col-md-6"> -->
                  <div class="details-left-bg">
                    <br>
                    <div class="details-left">
                      <ul>
                        <li id="leftli">License Code </li> <br>
                        <li id="leftli">GST Number </li> <br>
                        <li id="leftli">PAN</li> <br>
                        <li id="leftli">Currency</li> <br>
                        <li id="leftli">Bank Name</li> <br>
                        <li id="leftli">Bank Account Number</li> <br>
                        <li id="leftli">IFSC Code</li> <br>
                        <li id="leftli">SWIFT</li> <br>
                      </ul>
                    </div>
                  </div>
                <!-- </div> -->

                <!-- <div class="col-md-6"> -->
                  <div class="details-right-bg">
                    <br>
                    <div class="detail-right">
                      <ul>
                        <li><input type="text" formControlName="licenseCode" value={{userDetails.licenseCode}}/></li> <br>
                        <li><input type="text" formControlName="gstNumber" value={{userDetails.gstNumber}}/></li> <br>
                        <li><input type="text" formControlName="PAN" value={{userDetails.PAN}}/></li> <br>
                        <li><input type="text" formControlName="currency" value={{userDetails.currency}}/></li> <br>
                        <li><input type="text" formControlName="bankName" value={{userDetails.bankName}}/></li> <br>
                        <li><input type="text" formControlName="bankAccountNumber" value={{userDetails.bankAccountNumber}}/></li> <br>
                        <li><input type="text" formControlName="IFSC" value={{userDetails.IFSC}}/></li> <br>
                        <li><input type="text" formControlName="SWIFT" value={{userDetails.SWIFT}}/></li> <br>
                      </ul>
                    </div>
                  </div>
                <!-- </div> -->


              </div>
            </fieldset>
          </div>




        </div>
        <br><br>
        <hr>
        
        <div id="my_centered_buttons">
          <input class="btn" data-color="purple" style="font-size: 15px; font-weight: bolder; padding: 20px;" type="submit"  value="Update">
        </div>
      </form>
  </div>
</ng-container>

<ng-container *ngIf="role === 'MODERATOR'">

  
        <div class="view-account" style="margin-left:20px;">
    <h1>User Profile</h1>
      <form [formGroup]="moderatorForm" (ngSubmit)="onSubmit()">
        <div>
          <div>
            <fieldset>
              <br>
              <div>
                <h3>Personal Info</h3>
                  <div class="row">
                    <div class="col-md-5" >
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li id="leftli">User ID </li> <br>
                            <li id="leftli">Full Name </li> <br>
                            <!-- <li id="leftli">Domain </li> <br> -->
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" >
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li>
                            <input type="text" readonly formControlName="userName" value={{userDetails.userName}}/>
                            </li> <br>
                            <li>
                            <input type="text" formControlName="fullName" value={{userDetails.fullName}}/>
                            </li> <br>
                            <!-- <li> <input type="text" formControlName="domainName" value={{userDetails.domainName}}/>
                            </li> <br> -->
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li id="leftli">Phone Number </li> <br>
                          <li id="leftli">E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li><input type="text" formControlName="contactNumber" value={{userDetails.contactNumber}}/></li> <br>
                          <li><input type="text" formControlName="email" value={{userDetails.email}}/></li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        
        </div>
        <hr>
        <div id="my_centered_buttons">
          <input class="btn" data-color="purple" style="font-size: 15px; font-weight: bolder; padding: 20px;" type="submit"  value="Update">
        </div>
        <hr>
  </form>
    </div> 
</ng-container>

<ng-container *ngIf="role === 'TECHEXPERT'">
  <div class="view-account" style="margin-left:20px;">
    <h1>User Profile</h1>
      <form [formGroup]="techExpertForm" (ngSubmit)="onSubmit()">
        <div>
          <div id="left">
            <fieldset>
              <br>
              <div>
                <h3>Personal Info</h3>
                  <div class="row">
                    <div class="col-md-5" >
                      <div class="details-left-bg">
                        <br>
                        <div class="details-left">
                          <ul>
                            <li id="leftli">User ID </li> <br>
                            <li id="leftli">Full Name </li> <br>
                            <li id="leftli">Domain</li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" >
                      <div class="details-right-bg">
                        <br>
                        <div class="detail-right">
                          <ul>
                            <li><input type="text" readonly formControlName="userName" value={{userDetails.userName}}/></li> <br>
                            <li><input type="text" formControlName="fullName" value={{userDetails.fullName}}/></li> <br>
                            <li><input type="text" formControlName="domainName" value={{userDetails.domainName}}/></li> <br>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>
            <fieldset>
              <div>
                <br>
                <h3 class="fieldset-title green">Contact Info</h3>
                <div class="row">
                  <div class="col-md-5" >
                    <div class="details-left-bg">
                      <br>
                      <div class="details-left">
                        <ul>
                          <li id="leftli">Phone Number </li> <br>
                          <li id="leftli">E-mail</li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="details-right-bg">
                      <br>
                      <div class="detail-right">
                        <ul>
                          <li><input type="text" formControlName="contactNumber" value={{userDetails.contactNumber}}/></li> <br>
                          <li><input type="text" formControlName="email" value={{userDetails.email}}/></li> <br>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div style="margin-right:20px;">
            <fieldset>
              <br>
              <div class="row">
              <h3>Licence and Bank Details</h3>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="details-left-bg">
                    <br>
                    <div class="details-left">
                      <ul>
                        <li id="leftli">PAN</li> <br>
                        <li id="leftli">Bank Name</li> <br>
                        <li id="leftli">Bank Account Number</li> <br>
                        <li id="leftli">IFSC Code</li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="details-right-bg">
                    <br>
                    <div class="detail-right">
                      <ul>
                        <li><input type="text" formControlName="PAN" value={{userDetails.PAN}}/></li> <br>
                        <li><input type="text" formControlName="bankName" value={{userDetails.bankName}}/></li> <br>
                        <li><input type="text" formControlName="bankAccountNumber" value={{userDetails.bankAccountNumber}}/></li> <br>
                        <li><input type="text" formControlName="IFSC" value={{userDetails.IFSC}}/></li> <br>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!-- <br><br><br><br><br><br><br> -->
        
        <!-- <hr> -->
        
        <div id="my_centered_buttons_1">
          <input class="btn" data-color="purple" style="font-size: 15px; font-weight: bolder; padding: 20px;" type="submit"  value="Update">
        </div>
        <!-- <br><br> -->
      </form>
    </div>
</ng-container>

<!-- End of Form -->